import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ReviewGradeType } from '@core/services/study-session.service';

export type TrainReviewFeedbackLabels = {
  title: string;
  again: string;
  againDescription: string;
  hard: string;
  hardDescription: string;
  good: string;
  goodDescription: string;
  easy: string;
  easyDescription: string;
};

type TrainReviewFeedbackOption = {
  grade: ReviewGradeType;
  tone: 'again' | 'hard' | 'good' | 'easy';
  icon: string;
  labelKey: keyof TrainReviewFeedbackLabels;
  descriptionKey: keyof TrainReviewFeedbackLabels;
};

@Component({
  selector: 'app-train-review-feedback',
  templateUrl: './train-review-feedback.html',
  styleUrl: './train-review-feedback.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainReviewFeedback {
  readonly isBusy = input(false);
  readonly selectedReviewGrade = input(ReviewGradeType.None);
  readonly labels = input.required<TrainReviewFeedbackLabels>();
  readonly hiddenGrades = input<readonly ReviewGradeType[]>([]);

  readonly review = output<ReviewGradeType>();

  protected readonly options: TrainReviewFeedbackOption[] = [
    {
      grade: ReviewGradeType.Again,
      tone: 'again',
      icon: 'x-circle',
      labelKey: 'again',
      descriptionKey: 'againDescription',
    },
    {
      grade: ReviewGradeType.Hard,
      tone: 'hard',
      icon: 'frown',
      labelKey: 'hard',
      descriptionKey: 'hardDescription',
    },
    {
      grade: ReviewGradeType.Good,
      tone: 'good',
      icon: 'check-circle',
      labelKey: 'good',
      descriptionKey: 'goodDescription',
    },
    {
      grade: ReviewGradeType.Easy,
      tone: 'easy',
      icon: 'star',
      labelKey: 'easy',
      descriptionKey: 'easyDescription',
    },
  ];

  protected reviewButtonAriaLabel(option: TrainReviewFeedbackOption): string {
    const labels = this.labels();
    return `${labels[option.labelKey]}. ${labels[option.descriptionKey]}`;
  }

  protected isOptionVisible(option: TrainReviewFeedbackOption): boolean {
    return !this.hiddenGrades().includes(option.grade);
  }
}
